import { render } from "./DuplicateNameConfirmationModal.vue?vue&type=template&id=2e80e191"
import script from "./DuplicateNameConfirmationModal.vue?vue&type=script&lang=js"
export * from "./DuplicateNameConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__